/**
 * HomeARDemoPeopleDeskView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARDemoPeopleDesk
 */

import { useHomeARDemoPeopleDeskLogic } from '@/hooks/traits/useHomeARDemoPeopleDeskLogic';
import type { HomeARDemoPeopleDeskConfig } from '@/hooks/traits/useHomeARDemoPeopleDeskLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoPeopleLeave } from '@app/shared';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface HomeARDemoPeopleDeskViewProps {
  config?: Partial<HomeARDemoPeopleDeskConfig>;
}

export function HomeARDemoPeopleDeskView({ config: propsConfig }: HomeARDemoPeopleDeskViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, now, config } = useHomeARDemoPeopleDeskLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoPeopleLeave'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return null;
}

export default HomeARDemoPeopleDeskView;
